import React, { useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';

import { ApiServiceServerless, forceAuthRefreshAsync } from '../../../xhr_libs';
import AddEntityActionButtons from '../../../components/forms/AddEntityActionButtons';

import {
  ROLES,
  ROLE_NAMES_UPPER,
  ROLE_WEIGHTS,
} from '../../../helpers/RolesData';

const formStyle = {
  textAlign: 'left',
};

export default function OrganizationPortfolioTokenModal(props) {
  const {
    show,
    onHide,
    organizationId,
    setPortfolioOrganizations,
    showToast,
    roleWeight,
  } = props;

  const [shareToken, setShareToken] = useState('');
  const [role, setRole] = useState('user');

  const [isLoading, setIsLoading] = useState(false);

  const addPortfolio = (e) => {
    e.preventDefault();
    setIsLoading(true);
    ApiServiceServerless.put(
      `/portfolios/portfolio_organizations/token/${organizationId}/${shareToken}/${role}`,
      {},
      { authorization_id: organizationId }
    )
      .then(async (res) => {
        await forceAuthRefreshAsync();
        setPortfolioOrganizations((prev) => [...prev, res.data]);
        showToast(
          'success',
          'Success',
          `Your Organization was added to ${res.data.name}.`
        );
      })
      .catch((error) => {
        showToast('danger', 'Alert', error);
      })
      .finally(() => {
        onHide();
        setShareToken('');
        setIsLoading(false);
      });
  };

  const handleCancel = () => {
    onHide();
    setShareToken('');
  };

  const saveDisabled = !shareToken;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        Add your Organization to a Portfolio
      </Modal.Header>
      <Form style={formStyle}>
        <Modal.Body>
          <Row>
            <Col sm={12}>
              <Form.Group controlId='addPortfolioForm.token'>
                <Form.Label>
                  Share token
                  <span className='text-warning font-weight-bold pl-1'>*</span>
                </Form.Label>
                <Form.Control
                  data-id='port-token'
                  required
                  placeholder=''
                  onChange={(e) => setShareToken(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Role</Form.Label>
                <Form.Control
                  data-id='port-role'
                  as='select'
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                  }}
                >
                  {ROLES.map(
                    (role) =>
                      roleWeight >= ROLE_WEIGHTS[role] && (
                        <option key={role} value={role}>
                          {ROLE_NAMES_UPPER[role]}
                        </option>
                      )
                  )}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={handleCancel}
            submitDisabled={saveDisabled}
            onSubmit={addPortfolio}
            isSubmitting={isLoading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
